<template>
  <v-dialog
    v-model="dialog"
    persistent
    :max-width="maxWidth"
    :max-height="maxHeight"
  >
    <v-card>
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text class="text-center" v-if="camera">
        <v-img ref="img" :src="camera" />
        <div class="pt-3">
          {{ $t("roomControl.closeDialog", { val: timeLeft }) }}
        </div>
      </v-card-text>
      <v-card-text v-else>
        <span>{{ text }}</span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          :key="action.text"
          :to="action.to"
          color="primary"
          text
          @click="
            dialog = false;
            resetTimer();
          "
          v-for="action in actions"
        >
          {{ action.text }}
        </v-btn>
        <v-btn
          v-if="confirmation"
          @click="
            confirmationFn();
            dialog = false;
            resetTimer();
          "
          color="primary"
          text
          >{{ $t("general.ok") }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      maxWidth: 500,
      maxHeight: 500,
      timeLeft: 20,
      intervalId: null,
    };
  },
  methods: {
    ...mapActions("dialog", ["closeDialog"]),
    resetTimer() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
      this.timeLeft = 20;
    },
    startTimer() {
      this.resetTimer();
      this.intervalId = setInterval(() => {
        if (this.timeLeft > 1) {
          this.timeLeft--;
        } else {
          this.closeDialogAndResetTimer();
        }
      }, 1000);
    },
    adjustDimensions() {
      const img = this.$refs.img;
      const maxWidthDimension = this.maxWidth - 32;
      const maxHeightDimension = this.maxHeight - 32;

      let newWidth = img.width + 32;
      let newHeight = img.height + 32;

      if (img.width > img.height) {
        // calculate ratio based on width
        let ratio = img.height / img.width;
        newWidth = newWidth > maxWidthDimension ? maxWidthDimension : newWidth;
        newHeight = newWidth * ratio;
        img.style["max-width"] = `${newWidth}px`;
      } else {
        // calculate ratio based on height
        let ratio = img.width / img.height;
        newHeight =
          newHeight > maxHeightDimension ? maxHeightDimension : newHeight;
        newWidth = newHeight * ratio;
        img.style["max-height"] = `${newHeight}px`;
      }
    },
    loadImageAndAdjustDimensions(val) {
      const img = new Image();
      img.src = `data:image/jpeg;base64,${val}`;
      img.onload = () => this.adjustDimensions(img);
    },
    closeDialogAndResetTimer() {
      this.closeDialog();
      this.resetTimer();
    },
  },
  computed: {
    ...mapState({
      title: ({ dialog }) => dialog.title,
      text: ({ dialog }) => dialog.text,
      camera: ({ dialog }) => dialog.camera,
      actions: ({ dialog }) => dialog.actions,
      confirmation: ({ dialog }) => dialog.confirmation,
      confirmationFn: ({ dialog }) => dialog.confirmationFn,
    }),
    dialog: {
      get() {
        return this.$store.state.dialog.active;
      },
      set(val) {
        this.$store.commit("dialog/SET_ACTIVE", val);
      },
    },
  },
  created() {
    if (this.camera) {
      this.loadImageAndAdjustDimensions(this.camera);
    }
  },
  watch: {
    dialog(val) {
      if (val && this.camera) {
        this.startTimer();
      } else {
        this.closeDialogAndResetTimer();
      }
    },
    camera(val) {
      if (val) {
        this.loadImageAndAdjustDimensions(val);
      }
    },
  },
};
</script>
